import React, { SyntheticEvent } from "react";
import {
  Dropdown,
  Menu,
  Image,
  Container,
  DropdownItemProps,
} from "semantic-ui-react";
import {
  NavLink,
  Link,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import logo from "./images/lambda-phi-logo.png";
import { LoginInfo } from "./Utils/Login";
import { useAuth } from "react-oidc-context";
import { setCurrentUser } from "./Utils/ApiConfig";

interface MenuProps extends RouteComponentProps {
  loginInfo: LoginInfo;
  setLoginInfo: (input: LoginInfo) => void;
}

export default withRouter(LambdaPhiMenu);

function LambdaPhiMenu(props: MenuProps): JSX.Element {
  const auth = useAuth();

  async function handleLogout(
    event: SyntheticEvent,
    dropdownProps: DropdownItemProps
  ) {
    event.preventDefault();
    try {
      // Clear the current user from API config
      setCurrentUser(null);

      // Clear local state
      props.setLoginInfo({} as LoginInfo);

      // Sign out from Cognito using OIDC
      await auth.signoutRedirect({
        extraQueryParams: { logout_uri: window.location.origin, client_id: auth.settings.client_id }
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  var map = new Map([
    ["/mailinglists", "Mailing Lists"],
    ["/alumnidb", "Alumni DB"],
    ["/users", "Member Database"],
    ["/photos", "Photo Gallery"],
    ["/wiki", "Wiki"],
    ["/ordering", "Ordering & Donations"],
    ["/2021campaign", "2021 Campaign"],
    ["/contact", "Contact Us"],
    ["/myaccount", "My Account"], // Separate route for My Account
    ["/decade-v", "Decade V"],
  ]);

  let menuText = "Home";
  for (let entry of Array.from(map.entries())) {
    let key = entry[0];
    let value = entry[1];

    if (props.location.pathname.startsWith(key)) {
      menuText = value;
    }
  }

  return (
    <Menu inverted style={{ minHeight: "60px", height: "60px" }}>
      <Container>
        <Dropdown item text={menuText} style={{ display: "flex", alignItems: "center" }}>
          <Dropdown.Menu>
            {props.loginInfo.id ? (
              <>
                <Dropdown.Item disabled>
                  <div>Logged in as:</div>
                  <div>
                    {props.loginInfo.first_name} {props.loginInfo.last_name}{" "}
                    {props.loginInfo.chapter} {props.loginInfo.year}
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider></Dropdown.Divider>
              </>
            ) : (
              <></>
            )}
            <Dropdown.Item as={NavLink} to="/" exact>
              Home
            </Dropdown.Item>
            {props.loginInfo.id ? (
              <>
                <Dropdown.Item as={NavLink} to="/decade-v">
                  Decade V Reunion
                </Dropdown.Item>
                <Dropdown.Item as={NavLink} to="/mailinglists">
                  Mailing Lists
                </Dropdown.Item>
                <Dropdown.Item as={NavLink} to="/users">
                  Member Database
                </Dropdown.Item>
                <Dropdown.Item as={NavLink} to="/photos">
                  Photo Gallery
                </Dropdown.Item>
                <Dropdown.Item as={NavLink} to="/wiki">
                  Wiki
                </Dropdown.Item>
              </>
            ) : (
              <></>
            )}
            <Dropdown.Item as={NavLink} to="/contact">
              Contact Us
            </Dropdown.Item>
            {props.loginInfo.id ? (
              <>
                <Dropdown.Divider></Dropdown.Divider>
                <Dropdown.Item as={NavLink} to="/myaccount">
                  My Account
                </Dropdown.Item>
                <Dropdown.Divider></Dropdown.Divider>
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </>
            ) : (
              <></>
            )}
          </Dropdown.Menu>
        </Dropdown>

        <Menu.Item header as={Link} to="/" style={{ display: "flex", alignItems: "center" }}>
          <Image src={logo} style={{ height: "40px", width: "auto" }} />
        </Menu.Item>
      </Container>
    </Menu>
  );
}
